// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__2kw2L"};